import React from 'react';
import { Menu } from 'lucide-react';
import { Logo } from '@/components/layout/Header/Logo';
import styles from './Header.module.css';

interface MobileHeaderProps {
    onMenuToggle: () => void;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({ onMenuToggle }) => {
    return (
        <div className={`${styles.container} ${styles.mobileContainer}`}>
            <div className={styles.logo}>
                <Logo />
            </div>
            <button onClick={onMenuToggle} className={styles.burgerButton}>
                <Menu size={32} color="#22c55e" />
            </button>
        </div>
    );
};
